<template>
    <section class="cabinet-content-wrap">
        <SearchAndBasket />

        <template v-if="product">
            <section class="cabinet__breadcrumbs">
                <router-link to="/" class="cabinet__breadcrumbs-link"
                    >Главная</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link to="/catalog" class="cabinet__breadcrumbs-link"
                    >Каталог</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link
                    :to="{
                        name: 'CategoryID',
                        params: { id: product.CategoryID }
                    }"
                    class="cabinet__breadcrumbs-link"
                    >{{ product.type.category.Name }}</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link
                    :to="{
                        name: 'CategoryID',
                        params: {
                            id: product.CategoryID,
                            filter2SubcategoriesFromRoute: product.type
                        }
                    }"
                    class="cabinet__breadcrumbs-link"
                    >{{ product.type.Name }}</router-link
                >
                <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
                <router-link
                    :to="{
                        name: 'BrandsID',
                        params: { id: product.BrandID }
                    }"
                    class="cabinet__breadcrumbs-link"
                    >{{ product.brand.BrandName }}</router-link
                >
            </section>
            <div
                class="cabinet-product-card cabinet-product-card--supplier d-flex flex-column flex-lg-row"
            >
                <section
                    class="cabinet-product-detail d-flex flex-column flex-md-row justify-content-md-between w-100"
                >
                    <div class="cabinet-product-left">
                        <image-swiper :images="product.images" />

                        <div v-if="isMobile" class="d-md-none pt-4">
                            <h2 class="h2 cabinet-title pt-1">
                                {{ product.Name || product.type.Name }}
                            </h2>
                            <div class="subtitle1 pt-2">
                                <div v-if="product.Price > 0">
                                    {{ getFormattedNum(product.Price || 0) }}
                                    ₽{{ priceUnit }}
                                </div>
                                <div v-else>
                                    Цена не указана
                                </div>
                            </div>
                            <div class="pt-3 d-flex">
                                <adding-and-deleting-to-public-cart
                                    :item="product"
                                    :blue="true"
                                />
                            </div>
                        </div>

                        <div
                            v-if="product.sets.length"
                            class="pt-4 mt-4 garniture garniture--supplier"
                        >
                            <div class="d-flex align-items-center">
                                <div class="subtitle1">Гарнитур</div>
                                <p
                                    class="caption mb-0 pl-2 pt-1 text-gray garniture__number"
                                >
                                    {{ product.sets[0].set_article }}
                                </p>
                            </div>
                            <div
                                v-if="itemsInSet.length"
                                class="garniture__list d-flex flex-wrap align-items-center"
                            >
                                <div
                                    v-for="itemInSet in itemsInSet"
                                    :key="itemInSet.item_id"
                                    class="garniture__item"
                                >
                                    <router-link
                                        :to="{
                                            name: 'ProductID',
                                            params: { id: itemInSet.item_id }
                                        }"
                                    >
                                        <img
                                            :src="
                                                itemInSet.item.images.length
                                                    ? itemInSet.item.images[0]
                                                          .url
                                                    : ''
                                            "
                                            alt=""
                                        />
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="cabinet-product-right">
                        <div v-if="!isMobile" class="d-none d-md-block">
                            <h2 class="h2 cabinet-title pt-1">
                                {{ product.Name || product.type.Name }}
                            </h2>
                            <div class="subtitle1 pt-2">
                                <div v-if="product.Price > 0">
                                    {{ getFormattedNum(product.Price || 0) }}
                                    ₽{{ priceUnit }}
                                </div>
                                <div v-else>
                                    Цена не указана
                                </div>
                            </div>
                            <div class="pt-3 d-flex">
                                <adding-and-deleting-to-public-cart
                                    :item="product"
                                    :blue="true"
                                />
                            </div>
                        </div>

                        <div class="mt-4">
                            <cabinet-tabs :tabs="tabs">
                                <product-specifications
                                    slot="0"
                                    :product="product"
                                />
                                <product-inserts slot="1" :product="product" />
                                <product-description
                                    slot="2"
                                    :description="product.Description"
                                />
                            </cabinet-tabs>
                        </div>
                    </div>
                </section>
            </div>
        </template>

        <div v-else-if="this.error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="getProduct"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <p v-else>Loading...</p>
    </section>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import vClickOutside from 'v-click-outside'

import SearchAndBasket from '@/components/Public/SearchAndBasket'
import CabinetTabs from '@/components/Cabinet/Tabs'
import getNameById from '@/mixins/getNameById'
import checkDemoUser from '@/mixins/checkDemoUser.js'
import onResize from '@/mixins/on-resize.js'
import getFormattedNum from '@/utils/getFormattedNum'
import ProductSpecifications from '@/components/Cabinet/Product/Specifications'
import ProductDescription from '@/components/Cabinet/Product/Description'
import ProductInserts from '@/components/Cabinet/Product/Inserts'
import ImageSwiper from '@/components/Cabinet/Retailer/Product/Detail/DetailSwiper.vue'
import AddingAndDeletingToPublicCart from '@/components/Public/AddingAndDeletingToPublicCart'

export default {
    name: 'PublicCatalogProduct',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        ProductSpecifications: ProductSpecifications,
        ProductInserts: ProductInserts,
        ProductDescription: ProductDescription,
        CabinetTabs,
        ImageSwiper,
        SearchAndBasket,
        AddingAndDeletingToPublicCart
    },
    mixins: [getNameById, checkDemoUser, onResize],
    data() {
        return {
            product: null,
            error: false
        }
    },
    computed: {
        ...mapState('other', ['priceUnitOptions']),
        ...mapState('publicSets', ['itemsInSet']),
        ...mapGetters({
            publicCart: 'publicCart'
        }),
        priceUnit() {
            const unit = this.getNameById(
                this.priceUnitOptions,
                'abbr',
                'id',
                this.product.PriceUnit
            )

            return unit ? `/${unit}` : ''
        },
        tabs() {
            let tabs = ['Характеристики', 'Вставки']
            if (this.product && this.product.Description) {
                tabs.push('Описание')
            }
            return tabs
        }
    },
    created() {
        this.getProduct()
        this.setCartPublicFromLocStor()
        this.getInsertMaterials()
        this.getInsertFacets()
        this.getInsertColors()
    },
    methods: {
        ...mapActions(['setCartPublicFromLocStor']),
        ...mapActions('publicSets', ['getItemsInSet']),
        ...mapActions('insert', [
            'getInsertMaterials',
            'getInsertFacets',
            'getInsertColors'
        ]),
        getProduct() {
            this.error = false
            this.$axios
                .get(`/public/items/${this.$route.params.id}`)
                .then(async res => {
                    this.product = res.data

                    if (this.product.sets.length) {
                        await this.getItemsInSet({
                            setID: this.product.sets[0].set_id
                        })
                    }
                })
                .catch(() => {
                    this.error = true
                })
        },
        getFormattedNum
    }
}
</script>
